import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useDeviceType from '../common/useDeviceType';
import { useRef } from 'react';
import ModalPop from './ModalPop';

const Banner = () => {
    const bannerList = [
        {
            pc: 'images/banner1.png',
            mo: 'images/bannerM1.png',
        },
        {
            pc: 'images/banner2.png',
            mo: 'images/bannerM2.png',
        },
        {
            pc: 'images/banner3.png',
            mo: 'images/bannerM3.png',
        },
        {
            pc: 'images/banner4.png',
            mo: 'images/bannerM4.png',
        },
    ];

    const isMobile = useDeviceType();

    const popupRef = useRef<HTMLDivElement>(null);

    const openfunc = () => {
        popupRef.current!.style.display = 'block';
    };

    const closefunc = () => {
        popupRef.current!.style.display = 'none';
    };
    return (
        <>
            <ModalPop popupRef={popupRef} closefnc={closefunc} />
            <div className=" relative w-full h-full xl:pt-3">
                <Swiper
                    slidesPerView={1}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                        stopOnLastSlide: false,
                    }}
                    loop={true}
                    loopAdditionalSlides={2}
                    modules={[Autoplay]}
                    className="mySwipe relative w-full h-full"
                >
                    {bannerList.map((v, i) => (
                        <SwiperSlide key={`banner-${i}`} className="relative w-full h-full">
                            <img
                                alt={`집치워드림센터 유품정리·특수청소 이벤트 배너 ${i + 1}`}
                                onClick={openfunc}
                                className="!relative w-full h-full object-contain cursor-pointer"
                                src={isMobile ? v.mo : v.pc}
                                width={2558}
                                height={609}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    );
};

export default Banner;
